/* eslint-disable max-len */
import React, { useCallback } from 'react';
import Scrollbars from 'react-custom-scrollbars';
import { LFC } from '../../Legacy';
import { Position } from '../../ui/Position';
import { Popup, PopupProps } from '../popups/Popup';
import { Prompt } from './../../ui';
import { FormBoundary, useLeaveFormGuard } from './FormBoundary';
import { PreferencesLayout } from './PreferencesLayout';

const XScrollbars = Scrollbars as any;

const PreferencesPopupLayout: LFC<PopupProps> = ({ dismiss, args }) => {

    const guardedDismiss = useLeaveFormGuard(dismiss);
    const dismissIfNotInInput = useCallback(() => {
        const f = document.querySelector(':focus');
        if (!f?.matches('input')) guardedDismiss();
    }, [guardedDismiss]);

    return <Prompt name="popup" ignoreEnter ignoreMouse onAction={dismissIfNotInInput}>
        <Popup p="0">
            <XScrollbars className="scrollbars">
                <PreferencesLayout initialOption={args.initialOption} />
            </XScrollbars>
            <Position at="topRight" inset=".5">
                <Popup.Close onAction={guardedDismiss} />
            </Position>
        </Popup>
    </Prompt>;
};

export const preferencesPopup = (initialOption?: string) =>
    ({ ui: PreferencesPopup, fullscreen: true, args: { initialOption } });

export const PreferencesPopup: LFC<PopupProps> = (props) => {
    return <FormBoundary>
        <PreferencesPopupLayout {...props} />
    </FormBoundary>;
};
